import HcpCahOverview from "@/page-components-hcp/cah-overview";

export default function HcpCahOverviewPage() {
  
  return <HcpCahOverview />;
}

// Forward layout props to `_app` so it can wrap with the proper layout
HcpCahOverviewPage.getLayoutProps = (pageProps, router) => (
  typeof HcpCahOverview.getLayoutProps === 'function'
    ? HcpCahOverview.getLayoutProps(pageProps, router)
    : {}
);